module.exports = __webpack_public_path__ + "img/closeBtn.98655e69.svg";